// extracted by mini-css-extract-plugin
export default {"block":"infinite-items-blocks_block__2hYsp","separator":"infinite-items-blocks_separator__2QdJX","endOfPage":"infinite-items-blocks_endOfPage__1c4P5"};